export default "__VITE_ASSET__CYZI7tro__"